import { PayloadAction, createSlice } from '@reduxjs/toolkit'

type Filter = '' | 'only' | 'ignore'
type State = {
  virtual: Filter
  collegeFair: Filter
}

const INITIAL_STATE: State = {
  virtual: '',
  collegeFair: '',
}

const slice = createSlice({
  name: 'calendar-visit-type-filter',
  initialState: INITIAL_STATE,
  reducers: {
    changeFilter: (state, action: PayloadAction<{ name: 'virtual' | 'collegeFair'; value: Filter }>) => {
      const { name, value } = action.payload
      state[name] = value
    },
  },
})

export const actions = slice.actions
export default slice.reducer
